var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20V13",
    stroke: "#626466",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.99995H18.25C18.4744 2.99165 18.6952 3.05915 18.8766 3.19158C19.058 3.32401 19.1895 3.51365 19.25 3.72995L20.83 9.27995C20.9562 9.75939 21.0134 10.2544 21 10.75C21 11.3467 20.7629 11.919 20.341 12.3409C19.919 12.7629 19.3467 13 18.75 13C18.1533 13 17.581 12.7629 17.159 12.3409C16.7371 11.919 16.5 11.3467 16.5 10.75C16.5 11.3467 16.2629 11.919 15.841 12.3409C15.419 12.7629 14.8467 13 14.25 13C13.6533 13 13.081 12.7629 12.659 12.3409C12.2371 11.919 12 11.3467 12 10.75",
    stroke: "#626466",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.99995H5.75C5.52555 2.99165 5.30485 3.05915 5.12344 3.19158C4.94204 3.32401 4.81049 3.51365 4.75 3.72995L3.21 9.27995C3.07031 9.75744 2.99959 10.2524 3 10.75C3 11.3467 3.23705 11.919 3.65901 12.3409C4.08097 12.7629 4.65326 13 5.25 13C5.84674 13 6.41903 12.7629 6.84099 12.3409C7.26295 11.919 7.5 11.3467 7.5 10.75C7.5 11.3467 7.73706 11.919 8.15901 12.3409C8.58097 12.7629 9.15326 13 9.75 13C10.3467 13 10.919 12.7629 11.341 12.3409C11.7629 11.919 12 11.3467 12 10.75",
    stroke: "#626466",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStore);
export default __webpack_public_path__ + "static/media/icon_store.301fe691a695e9033690320cbb654e55.svg";
export { ForwardRef as ReactComponent };